/**
 * Pause — placeholder scene key referenced from index.js.
 *
 * The actual pause overlay is rendered as a Modal inside GameContainer
 * (it needs to live above the game scene without stopping the simulation
 * tick on the host). This file exists so the scene list in `bootGame()`
 * has a stable identifier and so future contributors have a single place
 * to extend the pause UI.
 */
export class Pause extends Phaser.Scene {
  constructor() {
    super('Pause');
  }

  create() {
    // Intentionally empty: see GameContainer._togglePause.
  }
}
